import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';

const SIM_POOLS_STATS_FIELDS = {
    POOLS_OVER_80_PERCENT_COUNT: {
        key: 'poolsOver80PercentCount',
        type: FIELD_TYPES.NUMBER
    },
    POOLS_OVER_LIMIT_COUNT: {
        key: 'poolsOverLimitCount',
        type: FIELD_TYPES.NUMBER
    }
};

export default SIM_POOLS_STATS_FIELDS;